module.exports = __webpack_public_path__ + "img/Mentor_WeChat_QR.686a9ada.svg";